import { Response } from 'express'
import { IBook, IPage } from 'marketing-site/@types/generated/contentful'
import { getAssignedVariations } from 'marketing-site/lib/abTests'
import getLocaleCodeAndPathFromUri from 'marketing-site/lib/getLocaleAndPathFromUri'
import getPageByPath from 'marketing-site/lib/getPageByPath'
import { getResource } from 'marketing-site/lib/learnDirectory'
import BookOrGuidePageContent from 'marketing-site/src/components/bespoke/resources/book-or-guide-content'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import Page from 'marketing-site/src/components/common/Page'
import { IAssignedVariations } from 'marketing-site/src/components/context/AssignedVariationsContext'
import { RESOURCES_SLUG } from 'marketing-site/src/library/utils/constants/slugs'
import { transformSeoMetadata } from 'marketing-site/src/transformers/SEOMetadata'
import { GetServerSideProps } from 'next'
import React from 'react'

export interface IProps {
  page: IPage
  assignedVariations: IAssignedVariations
  book: IBook
}

export default function GuidePage(props: IProps) {
  const { page, book } = props
  const { seo, title } = book.fields

  return (
    <EntryMarker entry={page}>
      <Page page={page} title={title} seo={seo && transformSeoMetadata(seo)}>
        <BookOrGuidePageContent book={book} />
      </Page>
    </EntryMarker>
  )
}

export const getServerSideProps: GetServerSideProps<IProps> = async function ({
  req,
  res,
  query,
  resolvedUrl,
}) {
  const page = (await getPageByPath(RESOURCES_SLUG)) as IPage
  const bookSlug = query.guide as string

  const { locale } = await getLocaleCodeAndPathFromUri(resolvedUrl.split('/') ?? [])
  const book = await getResource<IBook>('book', bookSlug, locale)

  if (!book) {
    ;(res as Response).redirect('/resources/guides')
    return { props: {} as IProps }
  }

  const assignedVariations = await getAssignedVariations(req, page)

  return {
    props: {
      page,
      assignedVariations,
      book: JSON.parse(JSON.stringify(book)),
    },
  }
}
